module.exports = __webpack_public_path__ + "static/img/houyiyichang1@2x.78136ca5.png";